import { useMemo } from 'react';
import type { PhoneNumber } from '../../../services/phoneService';
import { formatPin, getPrimaryPhoneNumber } from '../utils/dialInUtils';

export interface DialInData {
  primaryPhoneNumber: string | null;
  pin: string | null;
  isLoading: boolean;
  isLoadingPhoneList: boolean;
  isLoadingPin: boolean;
  hasError: boolean;
  hasLicenseError: boolean;
  phoneListError: Error | null;
  pinError: Error | null;
}

export function useDialInData(
  phoneList: PhoneNumber[] | undefined,
  isLoadingPhoneList: boolean,
  phoneListError: Error | null,
  pin: string | null,
  isLoadingPin: boolean,
  pinError: Error | null,
): DialInData {
  return useMemo(() => {
    const primaryPhoneNumber = getPrimaryPhoneNumber(phoneList);
    const isLoading = isLoadingPhoneList || isLoadingPin;
    const hasError = !!phoneListError || !!pinError;

    const checkIs403 = (error: Error | null): boolean => {
      if (!error) {
        return false;
      }

      return 'status' in error && (error as { status: number }).status === 403;
    };

    const hasLicenseError = checkIs403(phoneListError) || checkIs403(pinError);

    return {
      primaryPhoneNumber,
      pin,
      isLoading,
      isLoadingPhoneList,
      isLoadingPin,
      hasError,
      hasLicenseError,
      phoneListError,
      pinError,
    };
  }, [phoneList, isLoadingPhoneList, phoneListError, pin, isLoadingPin, pinError]);
}

export { formatPin };
